// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--lqDHi","uploadLabel":"uploadLabel--T4SfI","exampleBtn":"exampleBtn--EZaXW","markerAnimationScale":"markerAnimationScale--oktLS"};